const en: any = {
  message: {
    value: "This is an example of content translation.",
  },
  bookingTitle: { value: "I'm Booking Qurban" },
  countTilte1: {
    value: "Qurban Owner Information",
  },
  countMsg1: {
    value: "Please enter information about the qurban owners.",
  },
  countTilte2: {
    value: "Contact Information",
  },
  countMsg2: {
    value: "Enter your information as the person filling out the form.",
  },
  countTilte3: {
    value: "Payment Information",
  },
  countMsg3: {
    value: "Please Enter Your Credit Card Information.",
  },
  submit: {
    value: "SUBMIT",
  },
  totalQurban: {
    value: "Total share",
  },
  totalPayment: {
    value: "Total payment",
  },
  paymentType: {
    value: "Payment Type",
  },
  termsCondition: {
    value:
      '<p>I read and accept <span class"termsItem"> <span class="policyItem"> Terms and Conditions </span> </span> of Qurban Organization</p>',
  },
  termsEyyup: {
    value:
      '<p>I accepted the <span class="org-policy"> conditions </span> of the organization, I appointed <span class="termsItem with-hover"> <b> Related Persons </b> <span class="related-poeple">Emrah Sönmez, Faik Koç, M. Osman Özaslan, Abdülkerim Gür, Kemal Yörükoğlu, Fırat Özakdağ, Mustafa Erer</span> </span> as my proxy for the qurbans and slaughtering for the people whose names I have written.</p>',
  },
  thirdPerson: {
    value:
      '<p>I <span class="termsItem with-hover"><b>declare</b><span class="hover-popup">I accept and declare that I have obtained the consent of the relevant persons for the data belonging to the third parties (the power of attorney and/or the right holder) that I have shared with your Foundation for the purposes of granting the victim power of attorney and/or distributing the sacrificed meat, and that I undertake all kinds of legal responsibilities that may arise from unlawful personal data transfer.</span></span> that I have obtained their consent if I have shared data belonging to third parties.</p>',
  },
  OrganitionPolicyContent: {
    value:
      "<div class='mec-terms'><h2>18. MEC Uluslararası Kurban Organizasyonu Şartları</h2>   <p>18. MEC Uluslararası Kurban Organizasyonu ('Organizasyon') Mahmud Esad Coşan Eğitim, Kültür, Dostluk ve Yardımlaşma Vakfı ('MEC Vakfı') tarafından düzenlenmektedir. MEC Vakfı’na, Bakanlar Kurulunun 13/01/2014 tarihli ve 2014/5824 sayılı kararıyla vergi muafiyeti tanınmış ve Cumhurbaşkanının 07/03/2023 tarihli ve 2023/6907 sayılı kararıyla izin almadan yardım toplayabilen vakıflardan olmasına kararı verilmiştir.</p>   <p>Organizasyon kapsamında Endonezya'da yapılacak dağıtıma esas teşkil eden kurbanlık hayvanların temini, kesimi, paketlenmesi, soğuk zincir korunarak Endonezya'ya lojistiği süreçlerinde MEC Foundation (Avustralya); Endonezya'da ihtiyaç sahiplerinin tespiti ve kurban etlerinin dağıtımı süreçlerinde ise Yayasan Server (Endonezya) kuruluşları ile iş birliği yapılmaktadır.</p>   <p> Organizasyon'a ilişkin hüküm ve şartlar aşağıdaki gibidir:</p>   <ul>     <li>Organizasyon'un; kurban ibadeti şartlarına, yürürlükteki mevzuata, genel temizlik kurallarına ve hayvan haklarına uygun yürütülmesi için azami düzeyde hassasiyet gösterilmektedir.</li>     <li>Kurbanlık hayvanların belirlenmesinde, İslâmi gerekliliklere ve hassasiyetlere dikkat edilmektedir.</li>     <li>Organizasyon için ülkemizde kesimi yapılacak büyükbaş hayvanların ağırlığı ortalama 350 kg, Avustralya'da kesimi yapılacak küçükbaş hayvanların ağırlığı ise ortalama 45-50 kg olarak belirlenmektedir. Ülkemizde büyükbaş hayvanların, Avustralya'da küçükbaş hayvanların belirli bir kotası bulunmaktadır.</li>     <li>Ülkemizde yapılan kesimlere Diyanet İşleri Başkanlığı görevlileri ile noterler; Avustralya'da yapılan kesimlere ise Helal Tescil Kuruluşu görevlileri eşlik etmektedir.</li>     <li>Ülkemizde dağıtımı tercih eden vekâlet sahipleri tarafından kurban etlerinin dağıtımına (belirlenen kota kapsamında) gönüllü olarak katılma imkânı bulunmaktadır. Böyle bir tercihi olan vekâlet sahipleri ile süreç içerisinde iletişim kurulmaktadır.</li>     <li>Kurban etlerinin dağıtılacağı ihtiyaç sahipleri hem ülkemizde hem de Endonezya'da; ilgili kamu kurum ve kuruluşlarının da yardımı ile dağıtım yapılacak şehirlerdeki gönüllüler tarafından tespit edilmektedir.</li>     <li>Organizasyon kapsamında kesimler Balıkesir’de; dağıtımlar ise Adana, Adıyaman, Ankara, Bursa, Gaziantep, Hatay, İstanbul, Kahramanmaraş, Kayseri, Kocaeli, Konya, Malatya, Osmaniye, Sakarya ve Şanlıurfa’da gerçekleştirilmektedir.</li>     <li>Kesimden sonra elde edilen sakatat ve deri gelirleri MEC Vakfı’na aktarılmaktadır.</li>     <li>Kişisel verilerinizin mevzuata uygun olarak işlenmesine, verilerinizin mahremiyeti ile güvenliğinin sağlanmasına dikkat edilmektedir. Organizasyon için hazırlanan aydınlatma metnine <span class='policyItem'>buradan</span> ulaşılabilmektedir.</li></ul> </div>",
  },
  termsMessage: {
    value:
      '<h4 style="font-size: 16px; text-align:center; font-weight: 600;">Terms and  Conditions</h4><p>I accept the following conditions of Qurban donation via proxy.</p><p>The Payment method and information on our site is coded under the Secured Socket Layer (SSL) protocol. The 128 bit SSL data transmission prevents third party reading or alteration.</p><p>Upon payment, credit card information is sent to the bank encrypted and processed under provision. Under any circumstance, we do not store credit card information, thus preventing third party access to this information.</p><p>Mahmud Esad Cosan( MEC) Foundation Australia, does not IN ANY WAY OR FORM store your credit card information.</p><p>To protect your personal information, we recommend using your own PC. Ensure no monetary transactions are processed on shared computers open to the public such as internet cafés.</p><p>We process transactions in Australian Dollars. Your credit card payment may reflect local currency converted by your bank. Exchange value of the currency applied by your bank and international processing fees are not in association with our foundation.</p><p>Instalments do not apply to your payments. However, your bank may reflect your credit card repayments in instalments. This encompasses your banks’ processing.</p><p>All Wajib wakalah will be conducted and slaughtered within Australia\'s Eid al-Adha days. The Eid Day in Australia may vary by one day compared to other countries.</p><p>The Qurban price charged by our foundation includes costs to international transportation, customs, administration expenses and etc. Any amount that may remain is considered to be in the discretion of the foundation.</p>',
  },
  share: {
    value: "SHARE",
  },
  qurbanWakalah: {
    value: "Qurban Wakalah",
  },
  add: {
    value: "ADD",
  },
  wname: {
    value: "Name",
  },
  wMobile: {
    value: "MOBILE",
  },
  wemail: {
    value: "E-mail",
  },
  qurban: {
    value: "QURBAN",
  },
  qurbanTypeSelect: {
    value: "Select qurban type",
  },
  wakalah: {
    value: "WAKALAH",
  },
  qurbanqty: {
    value: "QURBAN QTY",
  },
  qurbanlişstempty: {
    value:
      "Qurban List is empty. You can add the wakalah by entering the required information in the fields above and clicking the ADD button",
  },
  sheep: {
    value: "Sheep - 3.750 TL - Indonesia (QUOTA IS FULL)",
  },
  cattle: {
    value: "Cattle - 5.900 TL - Türkiye",
  },
  wajib: {
    value: "Wajib",
  },
  aqiqah: {
    value: "Aqiqah (Newborn)",
  },
  nadhr: {
    value: "Nadhr (Vow-Oath)",
  },
  other: {
    value: "Sadaqah",
  },
  fieldcannotbeEmpty: {
    value: "This Field can not be empty!",
  },
  wakalahtelError: {
    value:
      "Please check your number and your country phone code (from the flag icon on the left of the phone information box) and try again.",
  },
  wemailerror: {
    value: "Invalid email address!",
  },
  fullname: {
    value: "Name Surname",
  },
  mobilephone: {
    value: "Mobile Phone",
  },
  country: {
    value: "Country",
  },
  city: {
    value: "City",
  },
  town: {
    value: "Town",
  },
  contactError: {
    value: "You must fill in the contact information completely!",
  },
  policyError: {
    value:
      "You must tick the first two boxes to complete the registration process!",
  },
  prevtotal: {
    value: "Total Amount",
  },
  prevContactTitle: {
    value: "Form Filler's Information",
  },
  prevWakalahTitle: {
    value: "Wakalah Owner(s)",
  },
  prevTitle: {
    value: "Please Check all Your Wakalah Information.",
  },

  tableheadOwner: {
    value: "Full Name",
  },
  tableheadPhone: {
    value: "Mobile",
  },
  tableheadEmail: {
    value: "Email",
  },
  tableheadQty: {
    value: "Quantity",
  },
  tableheadTypeNote: {
    value: "Qurban Type",
  },
  back: {
    value: "BACK",
  },
  payment: {
    value: "PAYMENT",
  },
  waiting: {
    value: "Please Wait...",
  },
  waitingMsg: {
    value: "Please wait, it may take a few seconds to process.",
  },
  successTitle: {
    value: "Your Qurban has been received successfully.",
  },
  sharePickup: {
    value: "Click if you want Qurban Meat Offer",
  },
  dear: {
    value: "Dear",
  },
  paymentSuccess: {
    value: "Your Qurban payment has been received successfully.",
  },
  qurbanData: {
    value:
      "Thank you for your interest in our {qurbanYear} International Qurban Organization.",
  },
  refrenceNo: {
    value: "Reference Number:",
  },
  totalPaid: {
    value: "Total Payment",
  },
  printBtn: {
    value: "PRINT",
  },
  home: {
    value: "Qurban Page",
  },
  notifTitle: {
    value: "ANNOUNCEMENT",
  },
  notifDate: {
    value: "1444/2023 year",
  },
  notifMsg: {
    value: "Qurban Wakalah acceptance has ended.",
  },
  notifThanks: {
    value: "Thank you for your interest.",
  },
  btnQuery: {
    value: "Query Booking",
  },
  wakalahQueryTitle: {
    value: "Query Your Booking",
  },
  queryBtnText: {
    value: "SUBMIT QUERY",
  },
  qureyDescText: {
    value:
      "Enter the reference number and the e-mail address that you used while filling the form, to access your qurban information.",
  },
  queryFormFiller: {
    value: "Person Filling The Form",
  },
  querytotalQurabnShare: {
    value: "Total Qurban / Share",
  },
  queryTotalpaid: {
    value: "Total Amount For Qurban",
  },
  queryPaymentStatus: {
    value: "Payment Status",
  },
  querySlaugtherStatus: {
    value: "Slaugther Status",
  },
  cardNumber: {
    value: "Card Number",
  },
  expiryDate: {
    value: "Expiry Date",
  },
  cvc: {
    value: "CVC",
  },
  removeCard: {
    value: "Remove",
  },
  paymentControlText: {
    value: "Before proceeding to payment check your information",
  },
  NameTransferText: {
    value:
      "I allow my name and surname information to be transferred to the person who will perform the slaughter in Australia.",
  },
  kvkkContent: {
    value:
      '<div class="kvkk-content"> <h1>KURBAN ORGANİZASYONU AYDINLATMA METNİ</h1> <br/> <h1>I. Veri Sorumlusu</h1> <br/> <p>6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, kişisel verileriniz; veri sorumlusu olarak Mahmud Esad Coşan Eğitim, Kültür, Dostluk ve Yardımlaşma Vakfı ("<b>MEC Vakfı</b>" veya "<b>Vakıf</b>") tarafından aşağıda açıklanan kapsamda işlenmektedir.</p> <br/> <h1>II. Kişisel Verileri Toplama Yöntemleri ve Hukuki Sebepleri</h1> <br/> <p>Kişisel veri, kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü veriyi kapsamaktadır. Kişisel verinin özel bir türü olan özel nitelikli kişisel veri ise ırk, etnik köken, siyasi düşünce, felsefi inanç, din, mezhep, diğer inançlar, kılık ve kıyafet, dernek, vakıf veya sendika üyeliği, sağlık, cinsel hayat, ceza mahkumiyeti ve güvenlik tedbirleri, biyometrik ve genetik verileri ifade eder.</p> <p>Vakfımız kişisel verileri; vekâlet sahibinin kendisinden veya yakınlarından, gönüllülerin kendisinden, sivil toplum kuruluşlarından veya kamu kurum ve kuruluşlarından, elektronik ortamda vekâlet formu doldurulmak suretiyle, Kanun’da belirtilen kişisel veri işleme şartlarına uygun ve kurban ibadetinin yerine getirilmesi amacıyla doğru orantılı olarak, Kanun’un 5. maddesinde belirtilen aşağıdaki hukuki sebepler doğrultusunda toplamaktadır:</p> <ul>     <li>Kanunlarda kişisel verilerinizi işlediğimiz sürecin açıkça öngörülmesi (örneğin, ayni yardımların dağıtılması için mevzuat gereği kullanılması gereken formlara kimlik verilerinizin işlenmesi veya imza alınması)</li>     <li>Sizlerle bir sözleşme ilişkisi kurmamız veya bu sözleşmeden kaynaklanan ifa yükümlülüğümüz ile doğrudan doğruya ilgili olması kaydıyla, sizlere ait kişisel verilerin işlenmesinin gerekli olması (örneğin, vekâlet bedelinin temin edilmesi için kredi kartı bilgilerinin alınması)</li>     <li>Hukuki yükümlülüğümüzü yerine getirebilmek için zorunlu olan durumlar (örneğin, bilgi güvenliği yükümlülüklerine uyumu temin etmek ve gerektiği durumlarda Kanun’a uyumu sağlamak için işlem kayıtlarının izlenmesi ve incelenmesi)</li>     <li>Sizlere bir hak tesis etmemiz, bu hakkı kullandırmamız veya korumamız için veri işlemek zorunda oluşumuz (örneğin, vekâlet sözleşmesi kapsamında kurban ibadetinizin sizin adınıza Vakfımız görevlilerince yerine getirilmesi amacıyla kimlik verilerinizin işlenmesi)</li>     <li>Gerekli olduğu durumlarda sizlerden aldığımız açık rızanız (örneğin, kurbanınızın yurt dışında dağıtılmasını istemeniz halinde kişisel verilerinizin yurt dışına aktarılması)</li> </ul> <h1>III. Veri Kategorileri ve Veri Türleri</h1> <br/> <table cellspacing="0" border="1">   <tr>     <td rowspan="4">1.</td>     <td rowspan="4">Vekâlet sahibi</td>     <td>Kimlik Bilgisi</td>     <td>Ad ve soyad</td>   </tr>   <tr>     <td >İletişim Bilgisi</td>     <td>İl, ilçe, e-posta adresi, cep telefonu</td>   </tr>   <tr >     <td>Finansal Bilgi</td>     <td>Kredi kartı bilgileri</td>   </tr>   <tr>     <td>Özel Nitelikli Kişisel Veri</td>     <td>Kurban vekâlet bilgileri</td>   </tr>   <tr>     <td rowspan="3">2.</td>     <td rowspan="3">Gönüllü</td>     <td>Kimlik Bilgisi</td>     <td>Ad ve soyad</td>   </tr>   <tr>     <td>İletişim Bilgisi</td>     <td>İl, ilçe, e-posta adresi, cep telefonu</td>   </tr>   <tr>     <td>Hukukî işlem</td>     <td>İmza</td>   </tr>   <tr>     <td rowspan="3">3.</td>     <td rowspan="3">Hak sahibi</td>     <td>Kimlik Bilgisi</td>     <td>Ad ve soyad, T.C. kimlik numarası</td>   </tr>   <tr>     <td>İletişim Bilgisi</td>     <td>Adres</td>   </tr>   <tr>     <td>Hukukî işlem</td>     <td>İmza</td>   </tr> </table> <br/> <h1>IV. Kişisel Verilerin Hangi Amaçla İşleneceği</h1> <br/> <p>Yukarıda belirtilen kişisel veriler, bu verileri Vakfımıza açıklamanıza konu olan; kurban vekâletinin alınması, vekâlet gereğinin yerine getirilmesi, elde edilen etlerin dağıtılması, gerekli iletişimin sağlanması, Vakfımızın ve üyesi olduğu Server Platformu’nun diğer organizasyon ve faaliyetleri hakkında bilgilendirme yapılması, gerekli hukuki ve resmi süreçlerin yerine getirilmesi amaçlarıyla işlenecektir.</p> <br/> <h1>V. İşlenen Kişisel Verilerin Aktarılması</h1> <br/> <p>Vakfımız, kişisel verilerinizi "bilme gereği" ve "kullanma gereği" ilkelerine uygun olarak, gerekli veri minimizasyonunu sağlayarak, gerekli teknik ve idari güvenlik tedbirlerini alarak işlemeye özen göstermektedir. Kurban ibadetinizin vekâleten yerine getirilmesi ve elde edilen kurban etlerinin dağıtımı süreçlerinin veri akışını zaruri kılması nedeniyle işlediğimiz kişisel verileri yalnızca bu amaçla sınırlı olarak üçüncü kişilere aktarmak durumundayız. Dolayısı ile kişisel verileriniz, söz konusu amacın gerçekleştirilmesi doğrultusunda ve bu amaçların yerine getirilmesi ile sınırlı olarak; kesimi gerçekleştirecek firma personeli ve et dağıtımını yapacak gönüllülerimiz ile paylaşılmaktadır. Bu sürecin doğru bir şekilde yerine getirilebilmesi için kişisel verilerinizin doğru ve güncel olması çok önemlidir.</p> <br/> <p>Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve bu amaçların yerine getirilmesi ile sınırlı olarak; Vakfımızca alınan vekâlet gereğinin yerine getirileceği tesislerdeki firma personeline, hak sahiplerine yapılacak dağıtımla sınırlı olmak üzere Vakıf gönüllülerine, bilişim altyapımızı sağlayan, işleten veya hizmet sunan iş ortaklarımıza ve hizmet sağlayıcılarımıza, kanunen yetkili kamu kurumları ve özel kişi veya kuruluşlar ile üçüncü kişilere, hukuki yükümlülüklerin yerine getirilmesi kapsamında avukatlar ve denetçilere, düzenleyici ve denetleyici kurumlar ile mahkeme ve icra müdürlükleri gibi sair resmi kurumlara, kişisel verilerinizi talep etmeye yetkili olan diğer kamu kurum veya kuruluşlarına işbu aydınlatma metninde belirtilen amaçlarla sınırlı olarak aktarılabilecek, yurt içinde veya yurt dışında işlenebilecektir.</p> <br/> <h1>VI. İlgili Kişinin Hakları</h1> <p>Kişisel verisi işlenen kişi olarak, Kanunun ilgili kişinin haklarını düzenleyen 11. maddesi kapsamındaki taleplerinizi (kişisel veri işlemeyi öğrenme, işlemeyle ilgili bilgi talep etme, işlemenin amaca uygunluğunu öğrenme, aktarım yapılan kişileri bilme, eksik veya yanlış işlemelerin düzeltilmesini isteme, silme veya yok edilmesini isteme, otomatik tüm işlemlerin üçüncü kişilere bildirilmesini isteme, analize itiraz etme, zararın giderilmesini talep etme) Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğe göre kullanmak için <a href="mailto:mec&#64;mec.org.tr">mec&#64;mec.org.tr</a> ile iletişime geçebilir veya <a href="https://mec.org.tr/kvkk-basvuru-formu" target="_blank">https://mec.org.tr/kvkk-basvuru-formu</a>adresinde yer alan formu kullanabilirsiniz.</p> </div>'
  },
  // contactPermitText:{
  //     value: 'I approve to the <span class="contact-policy"> processing of my information </span> in order to be aware of other activities and projects of the MEC Foundation.'
  // },
  contactPermitText: {
    value:
      'I <span class="termsItem with-hover"><b>declare</b><span class="hover-popup">I declare that I accept to be contacted through any channel about the other activities and organizations of the MEC Foundation and/or Server Platform, and that I have my express consent for this.</span></span> that I want to be informed about the activities of the MEC Foundation and the Server Platform.',
  },
  contactPermitContent: {
    value:
      "<div class=\"contact-permit\"> <h1>İletişim İzni</h1> <p>MEC Vakfı'nın diğer faaliyet ve projelerinden haberdar olmak için verilerin işlenmesine izin veriyorum</p> <p> bu ve diğer organizasyonlarda iş birliği yapılan Server Yaşam Vakfı ile Hakyol Vakfı'nın proje ve faaliyetlerinden haberdar olmak için verilerin aktarılmasına izin veriyorum </p> <p>Eğer gelecek yıllarda ülkemizde düzenlenecek kurban organizasyonunun farklı bir kurum tarafından yürütülmesi ihtimali varsa, MEC Uluslararası Kurban Organizasyonu'nun duyuru ve kampanyaları hakkında bilgilendirme yapmak için izin veriyorum</p>  </div>",
  },
  distributionCountry: {
    value: "Distribution Country",
  },
  distributionCity: {
    value: "Distribution Place",
  },
  distributechecktext: {
    value: "I want to take part in distribution",
  },
  distErrorMsg: {
    value: "Please select your a distribution country",
  },
  distribuCityErrorTxt: {
    value: "Please must select distribution city",
  },
  //  distMsg:{
  //     value:"From the country option; Select Australia to cut in <b>Australia</b> and distribute in Indonesia, or Turkey to cut in Turkey and distribute in <b>Turkey</b>."
  // },
  distMsg: {
    value:
      "Shared Wakalah onwers who want to take part in the distribution in Turkey will be contacted.",
  },
  cardholderName: {
    value: "Cardholder Name",
  },
  failureTitle: {
    value: "Payment transaction failed",
  },
  emptyCardInfoErrorTxt: {
    value: "Please enter your card details.",
  },
  wakalahForm: {
    value: "WAKALAH FORM",
  },
  payment3DError: {
    value:
      '<h2>Sorry!</h2> <div class="threederror-content"> <p>An unexpected situation occurred, Please try again later. </p> <p>If the problem persists, you can contact your bank.</p> </div> <span class="error-msg2">Error: "{0}"</span>',
  },
  notfoundMsg: {
    value:
      "Sorry, the page you are looking for does not exist or has been removed",
  },
  installmentPrice: {
    value: "Installment Amount",
  },
  nameTransferError: {
    value: "You must select this check box for your overseas wakaleh.",
  },
  disclaimerTxt: {
    value:
      '<span class="disclaimer">Your personal information obtained with this form will be processed for the purpose of fulfilling the qurban processes. For detailed information, you can review <span class="policyItem"> the enlightenment text.</span></span>',
  },
  indonesiaTxt: {
    value: "INDONESIA",
  },
  turkeyTxt: {
    value: "TÜRKİYE",
  },
  contactInfoTransferMsg: {
    value: "Copy the information I filled in to the field below",
  },
  Adres: "Address",
  "İhtiyaç sahibi önerin": "Suggest a needy",
  İPTAL: "CANCEL",
  "Kurban Eti İkramı": "Qurban Meat Offer",
  "Kurban Eti İkramı Almak İstiyorum": "I Want to Get a Qurban Meat Offer",
  "Kurban Eti İkramı Talep": "Qurban Meat Offer Request",
  "Ödeme Bilgileri": "Payment information",
  "Formu dolduran kişi olarak size ait bilgileri giriniz":
    "Enter your information as the person filling out the form",
  "(i) Ödeme öncesi işlemlerinizi kontrol ederek yeniden düzenleyebilirsiniz.":
    "(i) You can rearrange your pre-payment transactions by checking them.",
  "Hizmet Bedeli": "Service Fee",
  "Hizmet bedeli ödeme şartlarını kabul ediyorum":
    "I accept the service fee payment terms",
  "İhtiyaç Sahibi Öner": "Suggest to the Needy",
  "İletişim Bilgisi": "Communication information",
  "Formu dolduran kişi olarak ihtiyaç sahibinin bilgilerini giriniz":
    "Enter the information of the person in need as the person filling out the form",
  Tutar: "Amount",
  needySaved: `
    <div class='title33'>Information Of Needy</div>
    <b>Name Surname :</b> {0}<br/>
    <b>Cell Phone:</b> {1}<br/>
    <b>Address :</b> {2}<br/>
    {3} / {4}<br/>`,
  sharePickupResult: "You can get your qurban meat offer from the 2nd day of the holiday (June 29) between 12:00 and 18:00 at the <span style='color: #6DB5E3'>{0}</span> delivery point.",
  "Hatalı Kart": "Card invalid",
  takePartZone: {
    value: 'QURBAN MEAT OFFER DELIVERY POINT'
  },
  "Kurban Eti İkramı Hizmet Bedeli": "Service Fee For Qurban Meat Offer",
  "Uygulamamızda talep süreci sona ermiştir. İlginiz için teşekkür ederiz.": "The request process has ended in our application. Thank you for your attention.",
  "Büyükbaş kurbanlıklardan hazırlanan 4 kg kemiksiz et paketini, bayramın 2. gününde gel-al noktalarımızdan teslim alabilirsiniz.": "You can receive 4 kg of boneless meat package prepared from cattle sacrifices on the 2nd day of the feast from our pick-up points."
};

export default en;
